<template>
  <div>
    <h2>Easter Eggs: Books</h2>
    <!-- <p>Play with some Yuletide Main Collection 2018 stats! Minichallenges listed under a username indicate which minichallenges that participant has signed up for 2019; this data was crowdsourced and may contain errors.</p>
    <p>Stats may also contain errors if: fics were co-authored by more than one author, gifted to more than one person, were given to or recieved by orphaned accounts/anonymous users. Best effort attempts have been made to account for these edge cases!</p>
    <h3>Preset Filters</h3>
    <button class="btn" @click="filter('heroes')">No-Gift Heroes</button>
    <button class="btn" @click="filter('longfic')">Longfic (10K+ Words) Writers</button>
    <button class="btn" @click="filter('prolific')">Prolific (3 fics+) Writers</button>
    <button class="btn" @click="filter('nano')">NaNoYuleMo (50K+ Total Words)</button>
    <button class="btn" @click="filter('avg')">2+ Fics With High Average Words Warriors</button>
    <button class="btn" @click="filter('minichallenge')">Any Minichallenge</button>-->

    <table class="bonus table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Synopsis</th>
          <th>Subjects</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="book in meta" :key="book.name">
          <td>
            <router-link :to="'/fandom/' + book.index">{{book.name}}</router-link>
            <br />
            <br />
            <img v-if="book.meta.cover" :src="book.meta.cover.medium" />
          </td>
          <td>{{book.meta.excerpts ? book.meta.excerpts[0].text : ""}}</td>
          <td>
            <span class="chip" v-for="s in book.meta.subjects" :key="s.name + book.name">{{s.name}}</span>
            <span
              class="chip"
              v-for="s in book.meta.subject_places"
              :key="s.name + book.name"
            >{{s.name}}</span>
            <span
              class="chip"
              v-for="s in book.meta.subject_times"
              :key="s.name + book.name"
            >{{s.name}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import meta from "../data/book-meta.json";
export default {
  data() {
    return {
      meta
    };
  }
};
</script>

<style scoped lang="scss">
.btn {
  margin: 10px 10px 0 0;
}

// .th-small {
//   width: 80px;
// }

.small {
  width: 150px;
}
</style>

